import React, { useLayoutEffect, useRef } from "react"
import { useFrame, useLoader } from "react-three-fiber"
import { Vector3 } from "three"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
// import { useTweaks } from "use-tweaks"
// Convenience hook that selects a KHR material variant
function useVariant(variantIndex, ref, parser) {
    useLayoutEffect(() => {
        ref.current.traverse(async (object) => {
            if (!object.isMesh || !object.userData.gltfExtensions) return
            const meshVariantDef = object.userData.gltfExtensions["KHR_materials_variants"]
            if (!meshVariantDef) return
            if (!object.userData.originalMaterial) object.userData.originalMaterial = object.material
            const mapping = meshVariantDef.mappings.find((mapping) => mapping.variants.includes(variantIndex))
            if (mapping) object.material = await parser.getDependency("material", mapping.material)
        })
    }, [variantIndex, parser, ref])
}

/*
auto-generated by: https://github.com/pmndrs/gltfjsx
*/
export default function Model3D(props) {
    const ref = useRef()
    // Fetch model

    const { nodes, materials, userData, parser } = useLoader(GLTFLoader, props.path || "/motor.glb", (loader) =>
        loader.setPath("assets/models"),
    )
    // Create a GUI tweak panel
    //   const { colorway } = useTweaks({
    //     colorway: {
    //       value: 0,
    //       options: userData.gltfExtensions.KHR_materials_variants.variants
    //         .map((variant) => variant.name)
    //         .reduce((acc, name, index) => ({ ...acc, [name]: index }), {}),
    //     },
    //   })
    //   // Apply mapping
    //   useVariant(colorway, ref, parser)
    // Animate model
    useFrame((state) => {
        if (props.emissive) {
            const t = state.clock.getElapsedTime()
            let nd = 0;
            const v0 = -0.2 - (1 + Math.sin(t / 0.5)) / 20;
            const v1 = Math.cos(t / 4) / 8
            const v2 = Math.sin(t / 4) / 8
            const v3 = (1 + Math.sin(t / 1.5)) / 6
            nd = v0;
            ref.current.scale.z = nd * 1.5
            ref.current.scale.x = nd * 1.5
            ref.current.scale.y = nd * 1.5
            ref.current.rotation.x = 1.8;
            ref.current.rotation.z = 0;
            ref.current.rotation.y = 0;
            ref.current.rotation.z = v1
            ref.current.rotation.y = v2
            ref.current.rotation.x = v3

            return
        }

        switch (props.selector) {
            case 'x': {
                ref.current.rotation.x = 1.8;
                ref.current.rotation.z = 0;
                ref.current.rotation.y = 0;
                if (!props.active) break;
                ref.current.rotation.y = -0.05 + (Math.random() * 0.1)
                break;
            }
            case 'y': {
                ref.current.rotation.x = 1.8;
                ref.current.rotation.z = 1.6;
                ref.current.rotation.y = 0;
                if (!props.active) break;
                ref.current.rotation.y = -0.05 + (Math.random() * 0.1)
                break;
            }
            case 'z': {
                ref.current.rotation.x = 3.4;
                ref.current.rotation.z = 0;
                ref.current.rotation.y = 0;
                if (!props.active) break;
                ref.current.rotation.z = -0.05 + (Math.random() * 0.1)
                break;
            }
            default: {
                ref.current.rotation.x = 1.8;
                if (!props.active) break;
                ref.current.rotation.z = ref.current.rotation.z + 0.01;
            }
        }
    })

    return (
        <group ref={ref} {...props} >
            {Object.values(nodes).map((item, index) => {
                const config = {
                    metalness: 0.1,
                    roughness: 0.1,
                    color: props.color || 'blue',
                    opacity: props.active ? 1 : 0.6
                }
                switch (item.name) {
                    case ('08800498_2_2'):
                    case ('08800498_5'): {
                        config.color = 'rgb(120,120,120)';
                        break;
                    }
                    default: {
                        config.roughness = 0.2;
                        config.color = props.color || 'rgb(36,93,158)';
                    }
                }
                return (
                    <mesh key={index} onClick={() => console.log(item.name)} geometry={item.geometry} material={item.material} position={item.position} scale={new Vector3(0.008, 0.008, 0.008)} userData={item.userData} >
                        {/* {
                            !props.selector ?
                                <meshStandardMaterial attach="material" {...config} /> :
                                <meshBasicMaterial opacity={0.3} transparent={true} />
                        } */}
                        <meshStandardMaterial attach="material" {...config} transparent={true} />

                    </mesh>
                )
            })}
        </group>
    )
}
